import React, { Component } from 'react';
import KYCContainer from '../KYCContainer/KYC';
import VoterIDComponent from '../../../components/VoterID/Voterid';
import { FormHandler } from '../../../components/VoterID/FormHandler';
import window from 'window-or-global';

class VoterID extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onclick_handler = id => {
    if (id == 'voter_card' && window.innerWidth < 768) {
      document.getElementById('upload_front').style.display = 'block';
      let a = document.getElementById('doc_container');
      a.style.backgroundColor = 'black';
      a.style.height = '100%';
      a.style.position = 'absolute';
      a.style.opacity = '0.3';
      a.style.pointerEvents = 'none';
    }
  };
  OnSubmit = () => {
    FormHandler();
  };

  componentDidMount() {
    if (window.innerWidth < 768) {
      document.getElementById('mobile_custom_list').style.display = 'block';
      document.getElementById('mobile_doc_list').style.display = 'none';
    }
  }
  data = {
    pan: 'verification_pending',
    address: 'not_started',
    selfie: 'not_started',
    bank: 'not_started',
    ref: 'not_started',
    custom: 'null'
  };
  current_page = {
    pan: false,
    address: true,
    selfie: false,
    bank: false,
    ref: false
  };
  render() {
    window.addEventListener('resize', () => {
      this.onclick_handler('voter_card');
    });

    return (
      <div
        className="w-full"
        onLoad={() => {
          this.onclick_handler('voter_card');
        }}
      >
        <VoterIDComponent
          setCanProceed={this.props.setCanProceed}
          onclick_handler={this.onclick_handler}
          OnSubmit={this.OnSubmit}
        />
        {/* <KYCContainer guideName="Voter ID"  
                data={this.data} 
                curr_page = {this.current_page}  
                container={VoterIDComponent} 
                onclick_handler={this.onclick_handler} 
                OnSubmit={this.OnSubmit}/>
                <div className='w-full flex'>
                    <div className='w-1/4  mt-6 hidden md:block px-3 md:p-0'>
                    </div>
                    <div className='md:block text-center w-full md:w-3/4  mt-6 '>
                        <button className='w-1/2 md:w-1/4 text-white py-3 text-lg font-khand font-semibold bg-green-800 rounded-lg mx-auto hidden' 
                        onClick={this.OnSubmit} 
                        id='pan_upload_complete' >CONTINUE</button>
                    </div>
                </div> */}
      </div>
    );
  }
}
export default VoterID;
